import { computed } from 'vue'

import { ChatTabs } from '@shared/models/enums/tabs'
import { useGeneralStore } from '@shared/store/general'

import { Conversation } from '@protos/apps/vc/conversation_pb'
import { ConversationStatus } from '@protos/conversation_enums_pb'

import { useConversationsStore } from '@vc/store/conversations'

export const useCanAddConversation = (conversation: Conversation) => {
  const generalStore = useGeneralStore()
  const conversationsStore = useConversationsStore()

  const isAssigned = computed(() =>
    generalStore.isMe(conversation.assignee?.id)
  )

  const isParticipant = computed(() =>
    conversation.participants.find((participant) =>
      generalStore.isMe(participant.id)
    )
  )

  const isAssignedOrViewingAll = computed(
    () => isAssigned.value || conversationsStore.selectedTab === ChatTabs.All
  )

  const shouldDisplayConversationMatrix = {
    [ConversationStatus.OPEN]: () =>
      isAssignedOrViewingAll.value &&
      conversationsStore.selectedTab !== ChatTabs.Closed,
    [ConversationStatus.ASSIGNED_TO_BOT]: () =>
      isParticipant.value || isAssignedOrViewingAll.value,
    [ConversationStatus.INVITED]: () =>
      isParticipant.value || isAssignedOrViewingAll.value,
    [ConversationStatus.CLOSE]: () =>
      conversationsStore.selectedTab === ChatTabs.Closed,
  } as Record<Partial<ConversationStatus>, () => boolean>

  const shouldDisplayConversation = (status: Conversation['status']) =>
    shouldDisplayConversationMatrix[status]?.() || false

  const canAddAssignedConversation = computed(
    () =>
      (isAssigned.value &&
        conversationsStore.selectedTab !== ChatTabs.Closed) ||
      (!isAssigned.value && conversationsStore.selectedTab === ChatTabs.All)
  )

  return {
    isAssigned,
    isAssignedOrViewingAll,
    canAddAssignedConversation,
    shouldDisplayConversation,
  }
}
